// extracted by mini-css-extract-plugin
var _1 = "arrow__GXrWr";
var _2 = "arrow-box__f6PW0";
var _3 = "badge-count__MyMOy";
var _4 = "bg-accident__nd1w8";
var _5 = "bg-orange__lry9A";
var _6 = "bg-purple__bT7F4";
var _7 = "bg-red__cdxlC";
var _8 = "box__UKyuq";
var _9 = "box--with-info__EOhiU";
var _a = "content-box__UMown";
var _b = "count__BEJFh";
var _c = "counters-box__IVs5Z";
var _d = "footer__CyCYP";
var _e = "icon__w4yXG";
var _f = "icon-badge__FcOtu";
var _10 = "title__PiUMe";
export { _1 as "arrow", _2 as "arrow-box", _3 as "badge-count", _4 as "bg-accident", _5 as "bg-orange", _6 as "bg-purple", _7 as "bg-red", _8 as "box", _9 as "box--with-info", _a as "content-box", _b as "count", _c as "counters-box", _d as "footer", _e as "icon", _f as "icon-badge", _10 as "title" }
